// extracted by mini-css-extract-plugin
export default {"tooltip":"wM-z","arrow":"xM-z"};